import React from 'react'

const FieldWrapper = ({ children }) => {
  return (
    <div className="field">
      {children}
    </div>
  )
}

export default FieldWrapper
